export default class Operator {
    static EQUALS = "eq";
    static NOT_EQUALS = "ne";
    static SUPERIOR = "sup";
    static INFERIOR = "inf";
    static CONTAINS = "contains";
    static NOT_CONTAINS = "necontains";
    static START_WITH = "startWith";
    static END_WITH = "endWith";
    static JSON_CONTAINS = "jsoncontains";
    static JSON_NOT_CONTAINS = "nejsoncontains";
}